const shadows = [
  'none'
];

export default shadows;
